import { HitoCalendario } from '../models/calendario.models';

export const HITOS_CALENDARIO_MOCK: HitoCalendario[] = [
  {
    id: 'h-001',
    nombre: 'Apertura FONIS',
    fecha: '2026-01-15',
    estado: 'abierto',
    subdireccion: 'INVESTIGACION APLICADA',
  },
  {
    id: 'h-002',
    nombre: 'Cierre FONDECYT',
    fecha: '2026-01-29',
    estado: 'cerrado',
    subdireccion: 'PROYECTOS DE INVESTIGACION',
  },
  {
    id: 'h-003',
    nombre: 'Publicacion de bases',
    fecha: '2026-03-08',
    estado: 'abierto',
    subdireccion: 'CAPITAL HUMANO',
  },
  {
    id: 'h-004',
    nombre: 'Cierre admisibilidad',
    fecha: '2026-03-24',
    estado: 'cerrado',
    subdireccion: 'CAPITAL HUMANO',
  },
  {
    id: 'h-005',
    nombre: 'Apertura concurso I+D',
    fecha: '2026-04-12',
    estado: 'abierto',
    subdireccion: 'INVESTIGACION APLICADA',
  },
  {
    id: 'h-006',
    nombre: 'Webinar postulacion',
    fecha: '2026-04-12',
    estado: 'abierto',
    subdireccion: 'REDES, ESTRATEGIA Y CONOCIMIENTO',
  },
  {
    id: 'h-007',
    nombre: 'Resultados preliminares',
    fecha: '2026-04-26',
    estado: 'en_evaluacion',
    subdireccion: 'INVESTIGACION APLICADA',
  },
  {
    id: 'h-008',
    nombre: 'Apertura convocatoria regional',
    fecha: '2026-05-05',
    estado: 'abierto',
    subdireccion: 'CENTROS E INVESTIGACION ASOCIATIVA',
  },
  {
    id: 'h-009',
    nombre: 'Cierre convocatoria regional',
    fecha: '2026-05-28',
    estado: 'cerrado',
    subdireccion: 'CENTROS E INVESTIGACION ASOCIATIVA',
  },
  {
    id: 'h-010',
    nombre: 'Inicio evaluacion',
    fecha: '2026-06-10',
    estado: 'en_evaluacion',
    subdireccion: 'PROYECTOS DE INVESTIGACION',
  },
  {
    id: 'h-011',
    nombre: 'Entrega resultados',
    fecha: '2026-07-22',
    estado: 'cerrado',
    subdireccion: 'CAPITAL HUMANO',
  },
];
